<template>
  <v-select
    :items="selectItems"
    :style="{ width: selectInputWidth }"
    hide-details
    dense
    v-bind="$attrs"
    v-on="$listeners" />
</template>

<script>
export default {
  name: 'SelectDialog',
  props: {
    selectItems: {
      type: Array,
      required: true,
    },
    selectWidth: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    selectInputWidth() {
      return this.selectWidth
        ? `${String(this.selectWidth)}px`
        : 'auto'
    },
  },
}
</script>

<style scoped>
.v-input {
  margin: 2px 0 !important;
}
</style>
